import { render, staticRenderFns } from "./user.import.vue?vue&type=template&id=545f3354&"
import script from "./user.import.vue?vue&type=script&lang=js&"
export * from "./user.import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports